module.exports = __webpack_public_path__ + "img/488.65a163d4.jpg";